import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name='agent_assistance'
          control={control}
          defaultValue={''}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='agent_assistance'
              label='Agent Assistance'
              disabled={formSubmitting}
              error={Boolean(errors.agent_assistance)}
              helperText={errors.agent_assistance?.message as string | undefined}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default OutcomesForm;
